// src/api/uploads.ts

// Upload via the proxied relative endpoint so it works regardless of backend port.
// IMPORTANT: Do not return a blob: URL fallback here; callers should treat failure as an error
// and avoid persisting temporary object URLs into the database.
export async function uploadImage(file: File, opts?: { kind?: 'cover' | 'avatar' | 'seo' | string }) {
  const endpoint = `/api/uploads/image${opts?.kind ? `?kind=${encodeURIComponent(opts.kind)}` : ''}`;
  const form = new FormData();
  form.append('image', file); // server expects 'image'

  const res = await fetch(endpoint, {
    method: 'POST',
    body: form,
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Upload failed: ${res.status} ${text}`);
  }
  const data = await res.json(); // { url: string } or { relUrl }
  const url = String(data?.url || '').trim();
  // Accept absolute or relative returned URL as-is. If relative '/uploads/...', keep it
  // so the client origin or dev proxy can serve it correctly.
  return url || '';
}
